module.exports = {"220113001":"九台街道","220113002":"营城街道","220113003":"九郊街道","220113004":"西营城街道","220113005":"土们岭街道","220113006":"苇子沟街道","220113007":"兴隆街道","220113008":"纪家街道","220113009":"波泥河街道","220113010":"卡伦湖街道","220113011":"东湖街道","220113012":"龙嘉街道","220113013":"兴港街道","220113014":"沐石河街道","220113015":"城子街街道","220113102":"其塔木镇","220113103":"上河湾镇","220113200":"胡家回族乡","220113201":"莽卡满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220113.json
// module id = 697
// module chunks = 0